const FndPermissionItemFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: true,
        width: 70
    },
    {
        name: '类型',
        code: 'type',
        column: true,
        defaultFilter: true,
        width: 300
    },
    {
        name: '名称',
        code: 'targetName',
        column: true,
        defaultFilter: true
    }
]
export default FndPermissionItemFields;